// extracted by mini-css-extract-plugin
export default {"hackTerminalDoc":"HackTerminalDoc_hackTerminalDoc__KJTmK","hackTerminalDoc__title":"HackTerminalDoc_hackTerminalDoc__title__EPn-N"};